module.exports = __webpack_public_path__ + "img/folder5.6ae1d793.png";